export const createDateSelectFiltersObject = () => ({
    dateRangeType: "",
    startDate: "",
    endDate: "",
    noteType: ""
});